import cloneDeep from 'clone-deep';
import { autofill, change } from 'redux-form';
import {
    getIndexFromFieldName,
    isArrayValidAndNotEmpty,
    isValidFunction,
    roundedValueFixedToTwoDigits,
} from '../../constants/CommonUtil';
import { getStringFromObject } from '../../constants/lodashUtils';
import { NumberOf } from '../../constants/numberUtils';
import { isObjectValidAndNotEmpty } from '../../constants/nullCheckUtils';
import { add, multiply, getScaledAndRoundedBigDecimal, round } from '../../constants/PrecisionUtil';
import { PRICE_FOR_QUANTITY_ROUNDING_DIGITS } from '../../constants/constants';

export const extractAndSetValues = (rowValue) => {
    const newRowValue = cloneDeep(rowValue);
    const product = newRowValue.product ? newRowValue.product : {};
    let quantity;
    if (newRowValue.quantity !== null && newRowValue.quantity !== undefined && newRowValue.quantity !== '') {
        const numQuantity = NumberOf(newRowValue.quantity);
        // Allow decimals, but reset to 1 if value is 0 or negative
        quantity = numQuantity <= 0 ? 1 : numQuantity;
    } else {
        // Default to 1 if quantity is empty/null/undefined
        quantity = 1;
    }
    const baseUom = getStringFromObject('erpUomDto', product, {});
    const uom = isObjectValidAndNotEmpty(newRowValue.uom) ? newRowValue.uom : baseUom;
    const uomFactor = getStringFromObject('factor', uom, 1);
    const baseUomFactor = getStringFromObject('factor', baseUom, 1);
    const isSameUom =
        getStringFromObject('uuid', uom, null) &&
        getStringFromObject('uuid', baseUom, null) &&
        getStringFromObject('uuid', uom, null) === getStringFromObject('uuid', baseUom, null);
    const conversionFactor = isSameUom
        ? getScaledAndRoundedBigDecimal(1)
        : getScaledAndRoundedBigDecimal(NumberOf(uomFactor)).mul(1 / NumberOf(baseUomFactor || 1));
    const salePrice = newRowValue.salePrice == null ? NumberOf(product.price) : NumberOf(newRowValue.salePrice);
    const cost = newRowValue.salePrice == null ? NumberOf(product.cost) : NumberOf(newRowValue.cost);
    const weightedCost = (newRowValue.weightedCost == null || newRowValue.weightedCost === '') ? '' : NumberOf(newRowValue.weightedCost);
    const costPerUom = newRowValue.costPerUom == null ? NumberOf(product.defaultCost) : NumberOf(newRowValue.costPerUom);
    // eslint-disable-next-line no-underscore-dangle
    const shouldPreserveTotalCostPrice = newRowValue._preserveTotalCostPrice && newRowValue.totalCostPrice != null && newRowValue.totalCostPrice !== '';
    const totalCostPrice = shouldPreserveTotalCostPrice
        ? NumberOf(newRowValue.totalCostPrice)
        : round(conversionFactor.mul(costPerUom).mul(quantity), PRICE_FOR_QUANTITY_ROUNDING_DIGITS);
    const amount = multiply(quantity, salePrice);
    const taxes = newRowValue.taxes || [];
    let totalTax = 0;
    if (isArrayValidAndNotEmpty(taxes)) {
        taxes.forEach((tax) => {
            const newTax = multiply(NumberOf(tax.amount), amount);
            totalTax = add(totalTax, newTax);
        });
    }
    // Resetting after tax calculation
    newRowValue.total = roundedValueFixedToTwoDigits(add(amount, totalTax));
    // eslint-disable-next-line no-underscore-dangle
    if (!newRowValue._preserveQuantity) {
        newRowValue.quantity = quantity;
    }
    newRowValue.uom = uom;
    newRowValue.salePrice = roundedValueFixedToTwoDigits(salePrice);
    newRowValue.cost = roundedValueFixedToTwoDigits(cost);
    newRowValue.weightedCost = weightedCost;
    // eslint-disable-next-line no-underscore-dangle
    if (!newRowValue._preserveCostPerUom) {
        newRowValue.costPerUom = costPerUom;
    }
    newRowValue.totalCostPrice = totalCostPrice;
    newRowValue.mrp = roundedValueFixedToTwoDigits(salePrice);
    newRowValue.amount = roundedValueFixedToTwoDigits(amount);
    // Preserve trackByBatch from rowValue (set by mapper from productTrackByBatch), don't overwrite with product.trackByBatch
    // This ensures draft data maintains the correct trackByBatch value
    newRowValue.trackByBatch = getStringFromObject('trackByBatch', rowValue) !== undefined
        ? getStringFromObject('trackByBatch', rowValue)
        : getStringFromObject('product.trackByBatch', rowValue, false);
    newRowValue.uomCategoryId = getStringFromObject('erpUomDto.category.key', product) || 0;
    newRowValue.productId = getStringFromObject('productId', product) || 0;
    return newRowValue;
};

const setLine = (rowValue, index, dispatch, fields) => {
    console.log('asdfsdfsdfdsfdsf', rowValue, fields, typeof index);
    if (isObjectValidAndNotEmpty(fields)) {
        const valuesLength = fields.length;
        console.log('asdfsdfsdfdsfdsf', valuesLength);
        if (index === (valuesLength - 1).toString()) {
            // Add row automatically..
            fields.push({ uomCategoryId: 0, productId: 0 });
        }
    }
    if (isObjectValidAndNotEmpty(rowValue)) {
        const newRowValue = extractAndSetValues(rowValue);
        // dispatch(arrayRemove('addStockForm', 'addStock', index));
        dispatch(change('addStockForm', `addStock.${index}`, newRowValue));
    }
};

// Autocomplete on select handlers
const handleProductSelect = (product, formName, field, fields, dispatch) => {
    if (isObjectValidAndNotEmpty(product) && formName && field && isValidFunction(dispatch) &&
        isObjectValidAndNotEmpty(fields)) {
        const index = getIndexFromFieldName(field);
        if (index != null) {
            const rowValue = isValidFunction(fields.get) ? cloneDeep(fields.get(index)) : null;
            rowValue.product = product;
            rowValue.uom = product.erpUomDto;
            rowValue.cost = product.cost;
            rowValue.weightedCost = product.weightedCost == null ? '' : NumberOf(product.weightedCost);
            rowValue.costPerUom = product.defaultCost;
            rowValue.salePrice = null;
            // Allow decimals, but reset to 1 if value is 0, negative, or not a valid number
            const numQuantity = NumberOf(rowValue.quantity);
            rowValue.quantity = (numQuantity <= 0 || Number.isNaN(numQuantity)) ? 1 : numQuantity;
            rowValue.taxes = product.taxes || [];
            rowValue.expiry = '';
            // Set trackByBatch from product to control visibility of batch number and expiry date fields
            rowValue.trackByBatch = getStringFromObject('trackByBatch', product, false);
            setLine(rowValue, index, dispatch, fields);
        }
    }
};

const handleTaxSelect = (value, formName, field, fields, dispatch) => {
    if (isArrayValidAndNotEmpty(value) && formName && field && isValidFunction(dispatch) &&
        isObjectValidAndNotEmpty(fields)) {
        const index = getIndexFromFieldName(field);
        if (index != null) {
            const rowValue = isValidFunction(fields.get) ? cloneDeep(fields.get(index)) : null;
            if (isObjectValidAndNotEmpty(rowValue)) {
                rowValue.taxes = value;
                setLine(rowValue, index, dispatch);
            }
        }
    }
};

const quantityChangeHandler = (value, formName, field, fields, dispatch) => {
    if (formName && field && isValidFunction(dispatch) && isObjectValidAndNotEmpty(fields)
    ) {
        const index = getIndexFromFieldName(field);
        if (index != null) {
            const rowValue = isValidFunction(fields.get) ? cloneDeep(fields.get(index)) : null;
            if (isObjectValidAndNotEmpty(rowValue)) {
                rowValue.quantity = value;
                setLine(rowValue, index, dispatch);
            }
        }
    }
};

const rateChangeHandler = (value, formName, field, fields, dispatch) => {
    if (formName && field && isValidFunction(dispatch) && isObjectValidAndNotEmpty(fields)) {
        const index = getIndexFromFieldName(field);
        if (index != null) {
            const rowValue = isValidFunction(fields.get) ? cloneDeep(fields.get(index)) : null;
            if (isObjectValidAndNotEmpty(rowValue)) {
                rowValue.salePrice = value;
                setLine(rowValue, index, dispatch);
            }
        }
    }
};

const costPerUomChangeHandler = (value, formName, field, fields, dispatch) => {
    if (formName && field && isValidFunction(dispatch) && isObjectValidAndNotEmpty(fields)) {
        const index = getIndexFromFieldName(field);
        if (index != null) {
            const rowValue = isValidFunction(fields.get) ? cloneDeep(fields.get(index)) : null;
            if (isObjectValidAndNotEmpty(rowValue)) {
                rowValue.costPerUom = value;
                setLine(rowValue, index, dispatch);
            }
        }
    }
};

const uomChangeHandler = (value, formName, field, fields, dispatch) => {
    if (formName && field && isValidFunction(dispatch) && isObjectValidAndNotEmpty(fields)) {
        const index = getIndexFromFieldName(field);
        if (index != null) {
            const rowValue = isValidFunction(fields.get) ? cloneDeep(fields.get(index)) : null;
            if (isObjectValidAndNotEmpty(rowValue)) {
                rowValue.uom = value;
                setLine(rowValue, index, dispatch, fields);
            }
        }
    }
};

const rowChangeHandler = (value, formName, field, fields, dispatch) => {
    if (formName && field && isValidFunction(dispatch) && isObjectValidAndNotEmpty(fields)) {
        const index = getIndexFromFieldName(field);
        if (index != null) {
            const rowValue = isValidFunction(fields.get) ? cloneDeep(fields.get(index)) : null;
            let operation = rowValue.operation || 1;
            if (isObjectValidAndNotEmpty(rowValue)) {
                if (rowValue.uuid) {
                    operation = 2;
                }
            }
            dispatch(autofill(formName, `${field}.operation`, operation));
        }
    }
};

const deleteRowHandler = (selectedRows, fields, dispatch, instance) => {
    if (isArrayValidAndNotEmpty(selectedRows) && isValidFunction(dispatch) && isObjectValidAndNotEmpty(fields)) {
        selectedRows.forEach((idx) => {
            // const rowValue = isValidFunction(fields.get) ? cloneDeep(fields.get(idx)) : null;
            // if (isObjectValidAndNotEmpty(rowValue) && rowValue.orderLineUuid) {
            //     rowValue.operation = 3;
            //     arrayRemove('purchaseOrderForm', 'purchaseOrderLines', idx);
            //     arrayInsert('purchaseOrderForm', 'purchaseOrderLines', idx, rowValue);
            // } else {
            //     fields.remove(idx);
            //     if (instance != null) {
            //         instance.setState({ selected: selectedRows.splice(idx, 1) });
            //     }
            // }
            fields.remove(idx);
            if (fields.length === 1) {
                fields.push({});
            }
            if (instance != null) {
                instance.setState({ selected: selectedRows.splice(idx, -1) });
            }
        });
    }
};

export const ACTION_HANDLERS = {
    handleProductSelect,
    rateChangeHandler,
    costPerUomChangeHandler,
    quantityChangeHandler,
    rowChangeHandler,
    deleteRowHandler,
    handleTaxSelect,
    uomChangeHandler,
};

export default ACTION_HANDLERS;
